module.exports = __webpack_public_path__ + "img/DE02782.b4fcc074.png";